<template>
  <pf-modal v-if="modal" open @update:open="$event ? undefined : $emit('close')" variant="medium">
    <template #header>
      <h2 :class="modalStyles.modalBoxTitle">
        <span :class="modalStyles.modalBoxTitleText" ref="modalBoxTitleRef" />
      </h2>
    </template>

    <pf-empty-state v-if="!ready">
      <pf-empty-state-header :title="$t('Stiamo caricando il configuratore...')" heading-level="h4">
        <template #icon>
          <pf-empty-state-icon>
            <pf-spinner />
          </pf-empty-state-icon>
        </template>
      </pf-empty-state-header>
      <pf-empty-state-body>
        {{ $t('Ancora pochi istanti e potrai configurare il tuo server.') }}
      </pf-empty-state-body>
    </pf-empty-state>

    <template v-else>
      <wizard-progress />
      <wizard-step-prodotti-infrastruttura />
      <wizard-step-stack />
      <wizard-step-configurazione />
      <wizard-step-location />
      <wizard-step-summary />
    </template>

    <template #footer>
      <pf-flex space-items="sm" ref="modalFooterRef" />
    </template>
  </pf-modal>
</template>

<style scoped>
:deep(.pf-v6-c-radio) {
  margin-bottom: var(--pf-t--global--spacer--sm);
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import { useWizardSetup } from '@/wizard';
import WizardProgress from './wizard-progress.vue';
import WizardStepLocation from './steps/wizard-step-location.vue';
import WizardStepProdottiInfrastruttura from './steps/wizard-step-prodotti-infrastruttura.vue';
import WizardStepStack from './steps/wizard-step-stack.vue';
import WizardStepConfigurazione from './steps/wizard-step-configurazione.vue';
import WizardStepAddon from './steps/wizard-step-addon.vue';
import WizardStepClienti from './steps/wizard-step-clienti.vue';
import WizardStepAdd from './steps/wizard-step-add.vue';
import WizardStepSummary from './steps/wizard-step-summary.vue';

export default defineComponent({
  name: 'Wizard',

  inheritAttrs: false,

  components: {
    WizardProgress,
    WizardStepLocation,
    WizardStepProdottiInfrastruttura,
    WizardStepStack,
    WizardStepConfigurazione,
    WizardStepAddon,
    WizardStepClienti,
    WizardStepAdd,
    WizardStepSummary,
  },

  emits: ['close'],

  setup() {
    return useWizardSetup({
      modal: true,
      singlePath: 'cloud',
    });
  },
});
</script>
